import { faCheck, faClock, faFloppyDisk, faLocationPin, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { dispDateHour, tempAlWait } from "../helpers";
import { listParcActive } from "../actions/parc";
import { listRidesActive } from "../actions/rides";
import { connect } from "react-redux";
import Alert from "../components/Alert";
import { getWaitimeFilters, getWaitimeHisto } from "../actions/waitime";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'Chart.js Line Chart',
    },
  },
};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

export const data = {
  labels,
  datasets: [
    {
      label: 'Dataset 1',
      data: [10,20,30,40,50,60],
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
    },
    {
      label: 'Dataset 2',
      data: [20,30,40,50,60,10],
      borderColor: 'rgb(53, 162, 235)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)',
    },
  ],
};

class Waitime extends React.Component {
    state = {
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        openModal: false,
        parcs: [],
        attrs: [],
        datas: null,
        isStart: true,
        selParcs: ["all"],
        selRides: ["all"],
        period: [
            {
                opt: 'jour',
                txt: "Par jours"
            }, {
                opt: 'semaine',
                txt: 'Par semaines'
            }, {
                opt: 'mois',
                txt: 'Par mois'
            }, {
                opt: 'an',
                txt: 'Par années'
            }
        ],
        dates: [],
        selPeriod: 'jour',
        selDates: '',
        chartOpts: []
    }

    componentDidMount() {
        document.title = "Historique des temps d'attente - DiscovRide | Calendriers d'affluence, Temps d'attente de parcs d'attractions (Futuroscope, Parc Asterix...)";
        if (localStorage.getItem('parcsWaitime') != undefined) {
            this.setState({
                selParcs: JSON.parse(localStorage.getItem('parcsWaitime'))
            })
        }
        if (localStorage.getItem('ridesWaitime') != undefined) {
            this.setState({
                selRides: JSON.parse(localStorage.getItem('ridesWaitime'))
            })
        }

        if (this.props.canContinue) {
            this.props.listParcActive();
            this.setState({
                alert: tempAlWait()
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinue != this.props.canContinue) {
            if (this.props.canContinue) {
                this.props.listParcActive();
                this.setState({
                    alert: tempAlWait()
                });
            }
        }
        
        if (this.props.redParcsAct != prevProps.redParcsAct) {
            if (this.props.redParcsAct.alert.type == "succ") {
                this.setState({
                    alert: tempAlWait(),
                    parcs: this.props.redParcsAct.datas
                });
                this.props.listRidesActive({parcs: this.state.selParcs});
            } else {
                this.setState({
                    alert: this.props.redParcsAct.alert
                })
            }
        }

        if (this.props.redRidesAct != prevProps.redRidesAct) {
            if (this.props.redRidesAct.alert.type == "succ") {
                this.setState({
                    alert: tempAlWait(),
                    attrs: this.props.redRidesAct.datas
                });
                if (this.state.isStart) {
                    this.props.getWaitimeFilters({
                        parcs: this.state.selParcs,
                        period: this.state.selPeriod
                    });
                    this.props.getWaitimeHisto({
                        parcs: this.state.selParcs,
                        rides: this.state.selRides,
                        period: this.state.selPeriod,
                        dates: this.state.selDates
                    })
                }
            } else {
                this.setState({
                    alert: this.props.redRidesAct.alert
                })
            }
        }

        if (this.props.redGetWaitFilt != prevProps.redGetWaitFilt) {
            if (this.props.redGetWaitFilt.alert.type == "succ") {
                this.setState({
                    alert: tempAlWait(),
                    dates: this.props.redGetWaitFilt.datas,
                    selDates: this.props.redGetWaitFilt.datas[0]['opt']
                });
            } else {
                this.setState({
                    alert: this.props.redGetWaitFilt.alert
                })
            }
        }

        if (this.state.selDates != prevState.selDates) {
            this.props.getWaitimeHisto({
                parcs: this.state.selParcs,
                rides: this.state.selRides,
                period: this.state.selPeriod,
                dates: this.state.selDates
            })
        }

        if (this.state.selPeriod != prevState.selPeriod) {
            this.props.getWaitimeFilters({
                parcs: this.state.selParcs,
                period: this.state.selPeriod
            })
            this.setState({
                alert: tempAlWait()
            })
        }

        if (this.props.redGetWaitHisto != prevProps.redGetWaitHisto) {
            if (this.props.redGetWaitHisto.alert.type == "succ") {
                let tempDatas = this.props.redGetWaitHisto.datas;
                let res = null;
                if (tempDatas.length > 0) {
                    let tempLabels = tempDatas[0].dates;
                    let tempDatasets = [];
                    tempDatas.forEach(dt => {
                        let tempColor = `rgb(${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)})`;
                        tempDatasets.push({
                            label: dt.name,
                            data: dt.durees,
                            borderColor: tempColor,
                            backgroundColor: tempColor
                        });
                    })
                    res = {
                        data: {
                            labels: tempLabels,
                            datasets: tempDatasets
                        },
                        options: {
                            responsive: true,
                            plugins: {
                                legend: {
                                    position: 'top'
                                },
                                title: {
                                    display: true,
                                    text: "Historique des temps d'attente"
                                }
                            }
                        }
                    }
                }
                this.setState({
                    alert: this.props.redGetWaitHisto.alert,
                    datas: res,
                    openModal: false
                })
            } else {
                this.setState({
                    alert: this.props.redGetWaitHisto.alert
                })
            }
        }
    }

    cocheParc = (id) => {
        let res = false;

        if (this.state.selParcs.length > 0) {
            if (this.state.selParcs[0] == "all") {
                res = true;
            } else {
                if (this.state.selParcs.includes(id)) {
                    res = true;
                }
            }
        }
        return res;
    }

    cocheAttr = (id) => {
        let res = false;

        if (this.state.selRides.length > 0) {
            if (this.state.selRides[0] == "all") {
                res = true;
            } else {
                if (this.state.selRides.includes(id)) {
                    res = true;
                }
            }
        }

        return res;
    }

    handleCocheParc = (id, toAdd) => {
        let tempDatas = this.state.selParcs;
        if (toAdd) {
            if (tempDatas.length > 0) {
                if (tempDatas[0] == "all") {
                    tempDatas = [id];
                } else {
                    tempDatas.push(id);
                }
            } else {
                tempDatas = [id];
            }
        } else {
            if (tempDatas.length > 0) {
                if (tempDatas[0] == "all") {
                    tempDatas = [];
                    this.state.parcs.forEach(prc => {
                        if (prc.parcId != id) {
                            tempDatas.push(prc.parcId);
                        }
                    })
                } else {
                    tempDatas = tempDatas.filter(val => val != id);
                }
            }
        }
        this.props.listParcActive({parcs: tempDatas});
        this.setState({
            selParcs: tempDatas,
            alert: tempAlWait()
        })
    }

    handleCocheAttr = (id, toAdd) => {
        let tempDatas = this.state.selRides;
        if (toAdd) {
            if (tempDatas.length > 0) {
                if (tempDatas[0] == "all") {
                    tempDatas = [id];
                } else {
                    tempDatas.push(id);
                }
            } else {
                tempDatas = [id];
            }
        } else {
            if (tempDatas.length > 0) {
                if (tempDatas[0] == "all") {
                    tempDatas = [];
                    this.state.attrs.forEach(rd => {
                        if (rd.rideId != id) {
                            tempDatas.push(rd.rideId);
                        }
                    })
                } else {
                    tempDatas = tempDatas.filter(val => val != id);
                }
            }
        }
        this.setState({
            selRides: tempDatas
        })
    }

    handleSaveSettings = (el) => {
        el.preventDefault();

        localStorage.setItem('parcsWaitime', JSON.stringify(this.state.selParcs));
        localStorage.setItem('ridesWaitime', JSON.stringify(this.state.selRides));

        this.props.getWaitimeHisto({
            parcs: this.state.selParcs,
            rides: this.state.selRides,
            period: this.state.selPeriod,
            dates: this.state.selDates
        })
    }

    render() {
        return <div className="waitingp">
            <main className="main waitingp__main">
                <h2 className="main__ttl">Historique des temps d'attente</h2>

                {/** Boutons choix **/}
                <header className="waitingp__hdr">
                    <button
                        title="Choisir le parc d'attraction"
                        aria-label="Choisir le parc d'attraction"
                        className="waitingp__btn btn"
                        onClick={() => this.setState({openModal: !this.state.openModal})}
                    >
                        <FontAwesomeIcon icon={faLocationPin} />
                        <span className="btn__txt">Choix du parc et des attractions</span>
                    </button>
                    <Link
                        title="Temps d'attente"
                        aria-label="Temps d'attente"
                        to="/temps-attente"
                        className="waitingp__btn btn"
                    >
                        <FontAwesomeIcon icon={faClock} />
                        <span className="btn__txt">Temps d'attente</span>
                    </Link>
                </header>

                {/** Filtres **/}
                <div className="waitingp__filters">
                    {/** Période **/}
                    <select
                        className="waitingp__sel"
                        title="Sélectionner la période"
                        aria-label="Sélectionner la période"
                        onChange={(el) => this.setState({selPeriod: el.target.value})}
                    >
                        {
                            this.state.period.map((per, key) => {
                                return <option
                                    key={`per-${key}`}
                                    default={key == 0}
                                    className="waitingp__opt"
                                    selected={per.opt == this.state.selPeriod}
                                    value={per.opt}
                                >
                                    {per.txt}
                                </option>
                            })
                        }
                    </select>

                    {/** Dates **/}
                    <select
                        className="waitingp__sel"
                        title="Sélectionner la date"
                        aria-label="Sélectionner la date"
                        onChange={(el) => this.setState({selDates: el.target.value})}
                    >
                        {
                            this.state.dates.map((dt, key) => {
                                return <option
                                    key={`dt-${key}`}
                                    default={key == 0}
                                    className="waitingp__opt"
                                    selected={dt.opt == this.state.selDates}
                                    value={dt.opt}
                                >
                                    {dt.txt}
                                </option>
                            })
                        }
                    </select>

                </div>

                {/** Historique des temps d'attente graphique **/}
                {
                    this.state.datas != null &&
                    <Line options={this.state.datas.options} data={this.state.datas.data} />
                }
                {/**
                <LineChart
                    xAxis={[{data: this.state.datas.durees}]}
                    series={[{
                        data: this.state.datas.dates
                    }]}
                    height={300}
                /> **/}


                {/** Historique des temps d'attente tableau **/}

                {/** Modal choix du parc **/}
                <div className={`waitmod ${this.state.openModal && "waitmod--active"}`}>
                    <div className="waitmod__zone">
                        <button
                            title="Fermer la fenêtre"
                            aria-label="Fermer la fenêtre"
                            className="waitmod__btnclose"
                            onClick={() => {this.setState({openModal: !this.state.openModal})}}
                        >
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                        {/** Choix du parc **/}
                        <div className="waitmod__part">
                            <h3 className="waitmod__ttl">Choix du parc</h3>
                            <ul className="waitmod__list">
                                <li className="waitmod__item" title={"Sélectionner tous les parcs"} aria-label={"Sélectionner tous les parcs"} key={`parc--1`}>
                                    <button
                                        type="button"
                                        className="checkbox waitparcs"
                                        onClick={() => this.setState({selParcs: this.state.selParcs.length > 0 && this.state.selParcs[0] == "all" ? [] : ["all"]})}
                                    >
                                        <div className="checkbox__box waitmod__checkbox">
                                            <span className={`checkbox__check ${this.cocheParc(null) && "checkbox__check--active"}`}>
                                                <FontAwesomeIcon icon={faCheck} />
                                            </span>
                                        </div>
                                        <span className="checkbox__lab waitmod__checklab">Tout sélectionner</span>
                                    </button>
                                </li>
                                {
                                    this.state.parcs.map((parc, key) => {
                                        return <li className="waitmod__item" title={parc.name} aria-label={parc.name} key={`parc-${key}`}>
                                            <button
                                                type="button"
                                                className="checkbox waitparcs"
                                                onClick={() => this.handleCocheParc(parc.parcId, !this.cocheParc(parc.parcId))}
                                            >
                                                <div className="checkbox__box waitmod__checkbox">
                                                    <span className={`checkbox__check ${this.cocheParc(parc.parcId) && "checkbox__check--active"}`}>
                                                        <FontAwesomeIcon icon={faCheck} />
                                                    </span>
                                                </div>
                                                <span className="checkbox__lab waitmod__checklab">{parc.name}</span>
                                            </button>
                                        </li>
                                    })
                                }
                            </ul>
                        </div>

                        {/** Choix des attractions **/}
                        <div className="waitmod__part">
                            <h3 className="waitmod__ttl">Choix des attractions</h3>
                            <ul className="waitmod__list">
                                <li className="waitmod__item" title={"Tout sélectionner"} aria-label={"Tout sélectionner"} key={`attr--0`}>
                                    <button
                                        type="button"
                                        className="checkbox waitattrs"
                                        onClick={() => this.setState({selRides: this.state.selRides.length > 0 && this.state.selRides[0] == "all" ? [] : ["all"]})}
                                    >
                                        <div className="checkbox__box waitmod__checkbox">
                                            <span className={`checkbox__check ${this.cocheAttr(null) && "checkbox__check--active"}`}>
                                                <FontAwesomeIcon icon={faCheck} />
                                            </span>
                                        </div>
                                        <span className="checkbox__lab waitmod__checklab">{"Tout sélectionner"}</span>
                                    </button>
                                </li>
                                {this.state.attrs.map((attr, key) => {
                                    return <li className="waitmod__item" title={attr.name} aria-label={attr.name} key={`attr-${key}`}>
                                        <button
                                            type="button"
                                            className="checkbox waitattrs"
                                            onClick={() => this.handleCocheAttr(attr.rideId, !this.cocheAttr(attr.rideId))}
                                        >
                                            <div className="checkbox__box waitmod__checkbox">
                                                <span className={`checkbox__check ${this.cocheAttr(attr.rideId) && "checkbox__check--active"}`}>
                                                    <FontAwesomeIcon icon={faCheck} />
                                                </span>
                                            </div>
                                            <span className="checkbox__lab waitmod__checklab">{attr.name}</span>
                                        </button>
                                    </li>
                                })}
                            </ul>
                        </div>
                        {/** Validation **/}
                        <button
                            title="Valider ce choix"
                            aria-label="Valider ce choix"
                            className="waitmod__btn btn btn--secondary"
                            onClick={(el) => this.handleSaveSettings(el)}
                        >
                            <FontAwesomeIcon icon={faFloppyDisk} />
                            <span className="btn__txt">Enregistrer</span>
                        </button>
                    </div>
                </div>
                <Alert alert={this.state.alert} />
            </main>
        </div> 
    }
}

const mapStateToProps = state => {
    return {
        redRidesAct: state.redRidesAct,
        redParcsAct: state.redParcsAct,
        redGetWaitHisto: state.redGetWaitHisto,
        redGetWaitFilt: state.redGetWaitFilt
    }
}

const mapDispatchToProps = {
    listParcActive,
    listRidesActive,
    getWaitimeHisto,
    getWaitimeFilters
}

export default connect(mapStateToProps, mapDispatchToProps)(Waitime);